export default {
  web_title: "TopChat",
  phone: "18010190017",
  rewardTnum: 2000, // 邀请获取紫水晶数
  appId: "6446225721",
  domainUrl: "https://topchat.com.cn/",
  kfQQ: "1679711244",
  kfUrl: "https://support.qq.com/product/594273", // 客服url
  urlScheme: "wx65aae790839074d6://",
  year: new Date().getFullYear(),
  timeStamp: new Date().valueOf(), // 当前时间戳
  ICP: "京ICP备2023020663号-14",
  icpUrl: "https://beian.miit.gov.cn/#/Integrated/index",
  // AI默认内容
  defaultAIContent:
    "您好，我是您的AI助手~您可以询问我任何问题，我将知无不言，希望我们在一起能学到很多东西！",
  // 隐私协议
  privacyUrl: "https://au1uoskgdi.feishu.cn/docx/ELTqdu4Fzo7bnZxuWdzcHKKknOc",
  // 用户协议
  userAgreement:
    "https://au1uoskgdi.feishu.cn/docx/PKi0dZRpboMsiBxmEa4cF6Opnzh",
  // 注销协议
  logoffUrl: "https://au1uoskgdi.feishu.cn/docx/NX4BdrPQFomUlPxBgcRctzqMnDB",
  // 下载地址
  downloadAppUrl: "https://apps.apple.com/cn/app/6446225721",
  // 公网安备编号
  filings: "京公网安备 11010502052506号",
  // 公网安备地址
  filingsUrl:
    "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502052506",
};
